import(/* webpackMode: "eager" */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/node_modules/next/dist/client/link.js");
